var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVippsIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#jottacloud_vippsIcon.svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FF5B24",
  d: "M33.375 0H2.625A2.625 2.625 0 0 0 0 2.625v18.75A2.625 2.625 0 0 0 2.625 24h30.75A2.625 2.625 0 0 0 36 21.375V2.625A2.625 2.625 0 0 0 33.375 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M20.898 9.197c1.033 0 1.918-.784 1.918-1.911s-.885-1.911-1.918-1.911-1.918.784-1.918 1.91c0 1.128.885 1.912 1.918 1.912m2.508 3.087c-1.279 1.666-2.63 2.818-5.016 2.818-2.433 0-4.327-1.47-5.802-3.626-.59-.882-1.5-1.078-2.164-.613-.615.441-.76 1.373-.196 2.181 2.04 3.113 4.867 4.924 8.162 4.924 3.024 0 5.385-1.47 7.229-3.92.687-.906.663-1.837 0-2.352-.615-.49-1.525-.318-2.213.588",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "jottacloud_vippsIcon.svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h36v24H0z"
})))));
export default SvgVippsIcon;